import { services } from '../../services';
var action = "manage/report/";

export const manageReportService = {
    getServiceReport,
    getDebtAmountReport,
    getIncomeExpenseReport,
    getDebtAmountSummaryReport
};


function getServiceReport(param = '', uri='service-utility') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getDebtAmountReport(param = '', uri='debt-amount') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getDebtAmountSummaryReport(param = '', uri='debt-amount-summary') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getIncomeExpenseReport(param = '', uri='income-expense') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

